module.exports = __webpack_public_path__ + "static/media/NoirPro-Medium.6d74487d.eot";